module.exports = "<div class=\"cgp-fp-indicator {iconDisabled | inject} cgp-themes-icons-fp-indicator cy-game-navbar-free-play-indicator\">\r\n</div>\r\n";